import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import CookieManager from "../../utilities/CookieManager";
import UrlHelper from "../../utilities/UrlHelper";

import SiteSetupTable from "./SiteSetupTable";
import SiteSetupNewLinkDialog from "./SiteSetupNewLinkDialog";
import { getLinkedUsers, deleteUserLink, linkUserToSite, clearErrorMessage } from "../../actions/UsersActions";
import { loadSsoSettingsForSiteId } from "../../actions/OrganizationActions";

import NewLinkButton from "./NewLinkButton";
import DeleteConfirmationDialog from "../../controls/DeleteConfirmationDialog.jsx";

class SiteSetupContainer extends Component {
    constructor(props) {
        super(props);

        var currentSite = CookieManager.getSsoSiteId();
        this.state = {
            showConfirmationDialog: false,
            userIdToDelete: -1,
            currentSite: currentSite,
            showNewLinkDialog: false
        };

        this._handleSaveLink = this._handleSaveLink.bind(this);
        this._handleDeleteClicked = this._handleDeleteClicked.bind(this);
        this._handleDelete = this._handleDelete.bind(this);
        this.openSiteSetupDialog = this.openSiteSetupDialog.bind(this);
        this.closeSiteSetupDialog = this.closeSiteSetupDialog.bind(this);
        this.closeConfirmDeleteDialog = this.closeConfirmDeleteDialog.bind(this);
        this.onSiteIdChanged = this.onSiteIdChanged.bind(this);
        this.onLoginChanged = this.onLoginChanged.bind(this);
        this.onCheckSiteId = this.onCheckSiteId.bind(this);
        this._onSignOut = this._onSignOut.bind(this);
    }

    componentDidMount() {
        import("./_styles.scss");
        this.props.getLinkedUsers();
    }

    onSiteIdChanged (siteId) {
        this.setState({ currentSite: siteId });
    }

    onLoginChanged (value) {
        this.setState({ currentLogin: value });
    }

    openSiteSetupDialog () {
        this.setState({ showNewLinkDialog: true });
    }

    closeSiteSetupDialog () {
        this.setState({ showNewLinkDialog: false });
        this.props.clearErrorMessage();
    }

    closeConfirmDeleteDialog () {
        this.setState({ showConfirmationDialog: false });
        this.props.clearErrorMessage();
    }

    render() {
        var prevUrl = UrlHelper.getIdentifiUrl() + "ssoauth/ProductSelector";
        return (
            <div id="content">
                <div id="topRow">
                    <div className="col-md-3">
                        <h2>Multi-Site Set Up</h2>
                    </div>
                    <div className="col-md-6" id="spacer"/>
                    <div id="accessSiteLink">
                        <a href={prevUrl}><span id="TextSpan">Access Site</span></a>
                        <span className="glyphicon glyphicon-arrow-right" style={{ paddingLeft: "5px" }}/>
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-9"/>
                    <div className="col-md-3">
                        <NewLinkButton onClick={this.openSiteSetupDialog}/>
                    </div>
                </div>
                <SiteSetupTable linksList={this.props.linkedUsers}
                    onItemDeleteClick={userId => this._handleDeleteClicked(userId)}/>

                <SiteSetupNewLinkDialog id="newLinkDialog"
                    show={this.state.showNewLinkDialog}
                    onCancel={this.closeSiteSetupDialog}
                    onSave={this._handleSaveLink}
                    onCheckSiteId={this.onCheckSiteId}
                    currentSiteId={this.state.currentSite}
                    impersonateError={this.props.impersonateError}
                />

                <DeleteConfirmationDialog id="deleteConfirmationDialog"
                    title="Confirmation"
                    content="Are you sure you want to delete this link?"
                    show={this.state.showConfirmationDialog}
                    onCancel={this.closeConfirmDeleteDialog}
                    onDelete={this._handleDelete}
                />

                <div className="account-navigation col-xs-12">
                    <a id="logout" onClick={this._onSignOut}>Sign Out</a>
                </div>
            </div>
        );
    }


    _onSignOut() {
        window.location = UrlHelper.getLogoutUrl();
    }

    _handleSaveLink(site, login, currentPass) {
        this.props.linkUserToSite(site, login, currentPass).then((result) => {
            this.setState({ showNewLinkDialog: false });
        }).catch(ex => {});
    }

    onCheckSiteId (siteId) {
        if(siteId) {
            this.props.loadSsoSettingsForSiteId(siteId);
        }
    }

    _handleDeleteClicked (userId){
        this.setState({
            showConfirmationDialog: true,
            userIdToDelete: userId
        });
    }

    _handleDelete() {
        this.props.deleteUserLink(this.state.userIdToDelete);
    }
}

SiteSetupContainer.propTypes = {
    deleteUserLink: PropTypes.func,
    linkedUsers: PropTypes.array,
    impersonateError: PropTypes.any
};

const mapStateToProps = state => ({
    linkedUsers: state.siteSetupState.linkedUsers,
    impersonateError: state.siteSetupState.impersonateError
});

const mapDispatchToProps = (dispatch) => {
    return ({
        getLinkedUsers: () => dispatch(getLinkedUsers()),
        deleteUserLink: (userId) => dispatch(deleteUserLink(userId)).then(() => {
            dispatch(getLinkedUsers());
        }),
        linkUserToSite: (site, login, password) => dispatch(linkUserToSite(site, login, password)).then(() => {
            dispatch(getLinkedUsers());
        }).catch(ex => {
            throw(ex);
        }),
        loadSsoSettingsForSiteId: (siteId) => dispatch(loadSsoSettingsForSiteId(siteId)),
        clearErrorMessage: () => dispatch(clearErrorMessage())
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteSetupContainer);

